module.exports = __webpack_public_path__ + "img/sixpackcarrier54.d0d05bef.jpg";